import 'ksk/styledComponents/components/globals.js';
import './KskInputRico.css';

import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function KskInputRicoView({ value, className, label, height = 200, width = '100%', withLabel = true, autoHeight = false }) {
  const resolvedHeight = autoHeight ? 'auto' : height;

  return (
    <div className={`ksk-input-rico-view ${autoHeight ? 'ksk-input-rico-view--auto' : ''} ${className ?? ''}`.trim()} style={{ width }}>
      {withLabel && <label>{label}</label>}
      <ReactQuill
        value={value || ''}
        readOnly={true}
        theme="snow"
        style={{ height: resolvedHeight, backgroundColor: '#f9f9f9' }}
        modules={{
          toolbar: false, // desativa toolbar
          clipboard: { matchVisual: false }
        }}
      />
    </div>
  );
}

export default KskInputRicoView;